import PropTypes from 'prop-types';
import useCountdown from '@comp/Countdown/useCountdown';

const Timer = ({ timestamp, onExpire }) => {
  useCountdown(timestamp, onExpire);

  return null;
};

export default Timer;

Timer.propTypes = {
  timestamp: PropTypes.number.isRequired, // in milliseconds
  onExpire: PropTypes.func.isRequired
};
